<template>
    <div class="main-page">
        <PromoCarousel></PromoCarousel>
        <PromoActions></PromoActions>
        <PromoSales></PromoSales>
        <PromoPayment></PromoPayment>
        <PromoSalesMap v-if="indexPage != null && salesItems != null"></PromoSalesMap>
        <PromoSalesOther></PromoSalesOther>
        <PromoAbout></PromoAbout>
        <!-- <PromoNews></PromoNews> -->
        <formPage v-if="indexPage != null && salesItems != null"></formPage>
    </div>
</template>

<script>
    import PromoCarousel from '@/components/home-page/promo-carousel.vue'
    import PromoActions from '@/components/home-page/promo-actions.vue'
    import PromoSales from '@/components/home-page/promo-sales.vue'
    import PromoPayment from '@/components/home-page/promo-payment.vue'
    import PromoSalesMap from '@/components/home-page/promo-sales-map.vue'
    import PromoSalesOther from '@/components/home-page/promo-other-sales.vue'
    import PromoAbout from '@/components/home-page/promo-about.vue'
    // import PromoNews from '@/components/home-page/promo-news.vue'
    import formPage from '@/components/forms/form-page.vue'
	// import formPage from '@/components/forms/form-page.vue';	
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    export default {
        name: 'main--page',
        components: {
            PromoCarousel,
            PromoActions,
            PromoSales,
            PromoPayment,
            PromoSalesMap,
            PromoSalesOther,
            PromoAbout,
            // PromoNews,
            formPage,
            // formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP"',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            salesItems: 'loadSalesItems',
        }),
        methods: {
            // setLocale(lang) {
            //     localStorage.setItem('language', lang);
            //     document.location.reload(true);
            // }
        },
        beforeRouteEnter (to, from, next) {
            // store.dispatch('getFlatsPageData');
            // store.dispatch('getSalesPageData');
            // store.dispatch('getIndexPageData');
            // store.dispatch('getHypothecCalculatorPage');
            store.dispatch('getSalesItems');
            store.dispatch('getFilterCMSparamsData');
            store.dispatch('getPaymentPageData');
            next();
            if (store.state.indexPage != null) {
                next();
            } else {
                store.dispatch('getIndexPageData').then((response) => {
                    if (response) {
                        next();
                    } 
                    // else {
                    //     next(false, vm => vm.$parent.$refs.topProgress.fail());
                    // }
                });
            }
        },
        // beforeRouteUpdate (to, from, next) {
        //     // vm.$parent.$refs.topProgress.done();
        //     // next();
        // },
        beforeCreate() {
            document.body.dataset.page = 'home';
        },
        created () {
        },
        mounted() {
            // console.log('render')
            // this.$parent.$refs.topProgress.start();
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/about/about-page.scss';
</style>
